import { useAuthFeatureAuthCheckQuery } from "@/services/backend/auth/api/feature-auth";

export function useFeatureAuth(feature: string): boolean {
  const { data } = useAuthFeatureAuthCheckQuery({ feature });

  if (!data) {
    return false;
  }

  return data.hasAccess;
}
